'use strict';

// Needed for Safari & IE
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

const SELECTOR = '.js-scroll-to';

(function() {
	const links = document.querySelectorAll(SELECTOR);
	links.forEach(each => (each.onclick = scrollAnchors));
})();

function scrollAnchors(e, respond = null) {
	const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
	e.preventDefault();
    let offset = 0;

    let stickyHeader = document.querySelector('.sticky-header');

    if (stickyHeader) {
        offset = stickyHeader.offsetHeight;
    }

	var targetID = (respond) ? respond.getAttribute('href') : this.getAttribute('href');
	const targetAnchor = document.querySelector(targetID);

	if (!targetAnchor) return;

	var originalTop = distanceToTop(targetAnchor);
	var scrollOffset = this.dataset.scrollOffset;

	if (scrollOffset) {
		originalTop = (originalTop - scrollOffset)
	}

    originalTop -= offset;

	window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });

	const checkIfDone = setInterval(function() {
		const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
		if (distanceToTop(targetAnchor) === 0 || atBottom) {
			targetAnchor.tabIndex = '-1';
			targetAnchor.focus();
			window.history.pushState('', '', targetID);
			clearInterval(checkIfDone);
		}
	}, 100);
}